// extracted by mini-css-extract-plugin
export var hed = "creditssection-module--hed--VtcYX";
export var section = "creditssection-module--section--ZniPD";